import { createFileRoute, useRouter } from '@tanstack/react-router'
import { useClient } from '@/entities/client/model/queries'
import { AddSiteForm } from '@/features/client-profile/sections/client-sites/AddSiteForm'
import { Skeleton } from '@/shared/components/ui/skeleton'

export const Route = createFileRoute('/clients/$clientId/sites/new')({
  component: AddSitePage,
  staticData: { authorize: true },
})

function AddSitePage() {
  const router = useRouter()
  const { clientId } = Route.useParams()
  const clientIdNum = parseInt(clientId)

  const { data: client, isLoading: isLoadingClient } = useClient(clientIdNum)

  const handleBack = () => {
    router.history.back()
  }

  const handleSuccess = () => {
    router.history.back()
  }

  if (isLoadingClient) {
    return (
      <div className="space-y-6 p-6">
        <Skeleton className="h-10 w-48" />
        <Skeleton className="h-[600px] w-full" />
      </div>
    )
  }

  return (
    <AddSiteForm
      clientId={clientIdNum}
      clientName={client?.name}
      onBack={handleBack}
      onSuccess={handleSuccess}
    />
  )
}
